import qs from 'qs'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import config from '../../config.json'
import { getImage } from '../helpers/FormatLinks'
import Page from '../page/Page'
import SearchComponent from '../searchitems/'
import { Context } from '../waxplorer/Waxplorer'

const NewBuyOffer = (props) => {
    let values =
        typeof window !== 'undefined'
            ? qs.parse(
                  window.location.search.substring(
                      1,
                      window.location.search.length,
                  ),
              )
            : []

    const [state] = useContext(Context)

    const searchAuthor = state.searchAuthor
        ? state.searchAuthor
        : values['collection']

    const collectionDetails = props['collection_details']
    const collectionName = collectionDetails ? collectionDetails['name'] : null

    const { t } = useTranslation('common')

    const image = getImage(searchAuthor)

    return (
        <Page
            id={'NewBuyOfferPage'}
            title={config.titles.market.replace(
                '{collectionName}',
                collectionName ? 'for ' + collectionName : '',
            )}
            description={config.descriptions.market.replace(
                '{collectionName}',
                collectionName ? collectionName + ', ' : '',
            )}
            image={image}
            {...props}
        >
            <SearchComponent
                {...props}
                searchSettings={{
                    owner: '',
                    search_type: { value: 'summaries', fixed: true },
                    order_by: { value: 'volume_desc', fixed: false },
                    minimal: false,
                    tab: 'summaries',
                    searchOfferType: 'summaries',
                    page_component: false,
                    limit: { value: 60, fixed: true },
                    expanded: false,
                }}
                limit={60}
                tab={'summaries'}
                page={'newbuyoffer'}
            />
        </Page>
    )
}

export default NewBuyOffer
